<template>
  <div class="ticker" v-bottom-scrolled v-top-scrolled>
    <div class="ticker-dropdown-title">
      <span>{{$t(`trader.ticker.categoryDropdown`)}}</span>
      <div class="ticker-dropdown-wrapper">
        <div @click="showDropdown('dropdownCategories')"
             v-click-outside:dropdownCategories="closeDropdown.bind(closeDropdown,'dropdownCategories')"
             class="ticker-dropdown">
          <div class="ticker-dropdown-selection">
            <div class="ticker-dropdown-text">
              <span>{{$t(`trader.ticker.categories.${selectedCategory}`)}}</span>
            </div>
          </div>
          <div
            v-bind:class="{'ticker-dropdown-dropdown-arrow-open': dropdowns.dropdownCategories}"
            class="ticker-dropdown-dropdown-arrow">
            <v-icon>
              krypt-arrow-down
            </v-icon>
          </div>
        </div>
        <div class="ticker-dropdown-anchor">
          <div v-bind:class="{'ticker-dropdown-absolute-open':dropdowns.dropdownCategories}"
               class="ticker-dropdown-absolute ticker-dropdown-absolute-full">
            <div v-bind:class="{'ticker-dropdown-contents-open':dropdowns.dropdownCategories}"
                 class="ticker-dropdown-contents">

              <div
                v-for="option in categoryOfBetsOptions"
                class="ticker-dropdown-item"
                @click="selectCategoryOfBets(option)"
              >
                <div class="ticker-dropdown-item-selection">
                  <div class="ticker-dropdown-item-text">
                    <span>{{$t(`trader.ticker.categories.${option}`)}}</span>
                  </div>
                </div>
              </div>


            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="ticker-dropdown-container">
      <div class="ticker-dropdown-title ticker-dropdown-inline ticker-dropdown-inline-right">
        <span>{{$t(`trader.ticker.sport`)}}</span>
        <div class="ticker-dropdown-wrapper">
          <div @click="showDropdown('dropdownSports')"
               v-click-outside:dropdownSports="closeDropdown.bind(closeDropdown,'dropdownSports')"
               class="ticker-dropdown">
            <div class="ticker-dropdown-selection">
              <div class="ticker-dropdown-text">
                <span>{{selectedSport.name ? selectedSport.name : $t(`trader.ticker.all`)}}</span>
              </div>
            </div>
            <div
              v-bind:class="{'ticker-dropdown-dropdown-arrow-open':dropdowns.dropdownSports}"
              class="ticker-dropdown-dropdown-arrow">
              <v-icon>
                krypt-arrow-down
              </v-icon>
            </div>
          </div>
          <div class="ticker-dropdown-anchor">
            <div v-bind:class="{'ticker-dropdown-absolute-open':dropdowns.dropdownSports}"
                 class="ticker-dropdown-absolute">
              <div v-bind:class="{'ticker-dropdown-contents-open':dropdowns.dropdownSports}"
                   class="ticker-dropdown-contents">

                <div v-for="sport in sportsOptions"
                     class="ticker-dropdown-item"
                     @click="selectSport(sport)"
                >
                  <div class="ticker-dropdown-item-selection">
                    <div class="ticker-dropdown-item-text">
                      <span>{{sport.name ? sport.name : $t(`trader.ticker.all`)}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="ticker-dropdown-title ticker-dropdown-inline ticker-dropdown-inline-left">
        <span>{{$t(`trader.ticker.minStake`)}}</span>
        <div class="ticker-dropdown-wrapper ">
          <div @click="showDropdown('dropdownStake')"
               v-click-outside:dropdownStake="closeDropdown.bind(closeDropdown,'dropdownStake')"
               class="ticker-dropdown">
            <div class="ticker-dropdown-selection">
              <div class="ticker-dropdown-text">
                <span>{{selectedMinStake}}</span>
              </div>
            </div>
            <div
              v-bind:class="{'ticker-dropdown-dropdown-arrow-open':dropdowns.dropdownStake}"
              class="ticker-dropdown-dropdown-arrow">
              <v-icon>
                krypt-arrow-down
              </v-icon>
            </div>
          </div>
          <div class="ticker-dropdown-anchor">
            <div v-bind:class="{'ticker-dropdown-absolute-open':dropdowns.dropdownStake}"
                 class="ticker-dropdown-absolute">
              <div v-bind:class="{'ticker-dropdown-contents-open':dropdowns.dropdownStake}"
                   class="ticker-dropdown-contents">

                <div
                  v-for="minStake in minStakeOptions"
                  class="ticker-dropdown-item"
                  @click="selectMinStake(minStake)"
                >
                  <div class="ticker-dropdown-item-selection">
                    <div class="ticker-dropdown-item-text">
                      <span>{{minStake==='none'?$t('trader.ticker.none'):minStake}}</span>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="empty-ticker" v-if="tickerBets.length === 0 && tickerBetsHistorical.length === 0">
      <div class="empty-ticker-text">
        <div class="empty-ticker-image" v-if="!isFrozen">
          <v-icon>krypt-loader</v-icon>
        </div>
        <span>{{$t(`trader.ticker.waitingForNewBets`)}}</span>
      </div>
    </div>

    <div class="ticker-content">
      <transition-group name="slide">
        <TickerCard v-for="(tickerBet, index) in tickerBets" class="live-ticker-bet"
                    v-bind:key="tickerBet.id"
                    :tickerBet="tickerBet"></TickerCard>
      </transition-group>
      <TickerCard v-for="(tickerBet, index) in tickerBetsHistorical"
                  v-bind:key="tickerBet.id"
                  :tickerBet="tickerBet"></TickerCard>

      <div class="loading-bets" v-if="tickerBetsHistorical.length >= tickerMaxRealTimeBets && historyHasMoreBets"
      >
        <div class="loading-bets-text">
          <div class="loading-more-bets-image">
            <v-icon>krypt-loader</v-icon>
          </div>
          <span>{{$t(`loading`)}}</span>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import TickerCard from '@/components/other/tickerCard';

export default {
  name: 'Ticker',
  components: {
    TickerCard
  },
  data: function () {
    return {
      dropdowns: {
        dropdownCategories: false,
        dropdownSports: false,
        dropdownStake: false
      },
      _clickOutside: {
        shouldShowCategories: null,
        shouldShowSports: null,
        shouldShowStake: null
      },
      isScrolledDown: false
    };
  },
  mounted: function () {
    this.$store.commit('clearTickerBets'); /* added to avoid duplicate keys due to resizing */
    let categoryType = '';
    if (this.selectedCategory === 'botsBets' || this.selectedCategory === 'selectedEventBotsBets') {
      categoryType = 'BotOnly';
    } else if (this.selectedCategory === 'betweenUsers' || this.selectedCategory === 'selectedEventBetweenUsers') {
      categoryType = 'UserOnly';
    }
    this.$store.dispatch('getTickerBets', {
        minimumStake: this.$store.state.trader.ticker.selectedMinStake !== 'none' ? this.$store.state.trader.ticker.selectedMinStake : '',
        sportId: this.$store.state.trader.ticker.selectedSport !== 'all' ? this.selectedSport.id : '',
        eventId: this.selectedEvent !== 'none' && this.selectedCategory.includes('selectedEvent')? this.selectedEvent.id : '',
        userType: categoryType,
    });

  },
  computed: {
    categoryOfBetsOptions: function () {
      let options = [];
      if (this.selectedEvent === 'none') {
        options = [
          'allBets',
          'botsBets',
          'betweenUsers',
        ];
      } else {
        options = [
          'allBets',
          'botsBets',
          'betweenUsers',
          'selectedEventAllBets',
          'selectedEventBotsBets',
          'selectedEventBetweenUsers'];
      }
      return options;
    },
    historyHasMoreBets: function () {
      return this.$store.state.trader.ticker.historyHasMoreBets;
    },
    tickerMaxRealTimeBets: function () {
      return this.$store.state.trader.ticker.tickerMaxRealTimeBets;
    },
    selectedEvent: function () {
      return this.$store.state.navigations.selectedEvent;
    },
    minStakeOptions: function () {
      return ['none', 5, 10, 15, 20, 25, 50, 100, 150, 200, 250, 500];
    },
    selectedCategory: function () {
      return this.$store.state.trader.ticker.selectedCategoryOfBets;
    },
    selectedSport: function () {
      return this.$store.state.trader.ticker.selectedSport !== 'all' ? this.$store.state.trader.ticker.selectedSport :
        this.$t('trader.ticker.all');
    },
    selectedMinStake: function () {
      return this.$store.state.trader.ticker.selectedMinStake !== 'none' ? this.$store.state.trader.ticker.selectedMinStake :
        this.$t('trader.ticker.none');
    },
    sportsOptions: function () {
      let sports = this.$store.state.navigations.sports.map(function (sportData) {
        let sportDataLocalised = sportData;
        sportDataLocalised.name = this.$t(`sports.${sportData.sportIdentifier}`);
        return sportDataLocalised;
      }.bind(this));
      sports.splice(0, 1);
      sports.sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });

      return ['all'].concat(sports);
    },
    tickerBets: function () {
      return this.$store.state.trader.ticker.tickerBets.slice()
        .reverse();
    },
    tickerBetsHistorical: function () {
      return this.$store.state.trader.ticker.tickerBetsHistorical;
    },
    onHoldTickerBets: function () {
      return this.$store.state.trader.ticker.tickerBetsOnHold;
    },
    isFrozen: function () {
      return this.$store.state.trader.ticker.tickerIsFrozen;
    }
  },
  watch: {
    selectedEvent: function (newEvent, oldEvent) {
      if (newEvent === 'none') {
        this.selectCategoryOfBets('allBets');
      } else if (oldEvent === 'none') {
        this.selectCategoryOfBets('selectedEventAllBets');
      }
      ;
    }
  },
  methods: {
    getHistoricalTickerBetsForFilters: function (id) {
      let categoryType = '';
      if (this.selectedCategory === 'botsBets' || this.selectedCategory === 'selectedEventBotsBets') {
        categoryType = 'BotOnly';
      } else if (this.selectedCategory === 'betweenUsers' || this.selectedCategory === 'selectedEventBetweenUsers') {
        categoryType = 'UserOnly';
      }
      this.$store.dispatch('getTickerBets', {
        lastId: id,
        minimumStake: this.$store.state.trader.ticker.selectedMinStake !== 'none' ? this.$store.state.trader.ticker.selectedMinStake : '',
        sportId: this.$store.state.trader.ticker.selectedSport !== 'all' ? this.selectedSport.id : '',
        eventId: this.selectedEvent !== 'none' && this.selectedCategory.includes('selectedEvent')? this.selectedEvent.id : '',
        userType: categoryType,
      });

    },
    calculateTickerBetKey: function (index) {
      if (this.isScrolledDown) {
        return this.tickerBets.length - index;
      } else {
        return index - this.tickerBets.length;
      }
    },
    selectSport: function (sport) {
      this.$store.commit('setSelectedSportForTicker', sport);
      this.$store.commit('clearOnHoldBets');
      this.$store.commit('clearTickerBets');
      this.$store.commit('setTickerIsFrozen', false);
      this.getHistoricalTickerBetsForFilters();
      // this.$store.commit('clearTickerBets')
      // this.$store.commit('clearOnHoldBets')
    },
    selectCategoryOfBets: function (categoryOfBets) {
      this.$store.commit('setSelectedCategoryOfBets', categoryOfBets);
      this.$store.commit('clearOnHoldBets');
      this.$store.commit('clearTickerBets');
      this.$store.commit('setTickerIsFrozen', false);
      this.getHistoricalTickerBetsForFilters();
      // this.$store.commit('clearTickerBets')
      // this.$store.commit('clearOnHoldBets')

    },
    selectMinStake: function (minStake) {
      this.$store.commit('setSelectedMinStake', minStake);
      this.$store.commit('clearOnHoldBets');
      this.$store.commit('clearTickerBets');
      this.$store.commit('setTickerIsFrozen', false);
      this.getHistoricalTickerBetsForFilters();
      // this.$store.commit('clearTickerBets')
      // this.$store.commit('clearOnHoldBets')
    },
    showDropdown: function (dropdown) {
      this.dropdowns[dropdown] = !this.dropdowns[dropdown];
    },
    closeDropdown: function (dropdown) {
      this.dropdowns[dropdown] = false;
    },
    changeFilter: function (selectedFilter) {
      this.showDropdown();
    }
  },
  directives: {
    clickOutside: {
      componentUpdated: function (el, binding, vnode) {
        setTimeout(() => {
          const handler = (e) => {
            if (!el.contains(e.target) && el !== e.target && vnode.context.$data.dropdowns[binding.arg]) {
              binding.value(e);
            }
          };
          if (vnode.context.$data.dropdowns[binding.arg]) {
            if (vnode.context.$data._clickOutside[binding.arg] == null) {
              vnode.context.$data._clickOutside[binding.arg] = handler;
              document.addEventListener('click', vnode.context.$data._clickOutside[binding.arg]);
            }
          } else {
            document.removeEventListener('click', vnode.context.$data._clickOutside[binding.arg]);
            vnode.context.$data._clickOutside[binding.arg] = null;
          }
        }, 100);
      },
      unbind: function (el, binding, vnode) {
        document.removeEventListener('click', vnode.context.$data._clickOutside[binding.arg]);
        vnode.context.$data._clickOutside[binding.arg] = null;
      }
    },
    bottomScrolled: {
      inserted: function (el, binding, vnode) {
        const target = vnode.context.$el.parentElement;
        target.addEventListener('scroll', function (e) {
          if (Math.abs(target.scrollTop - (target.scrollHeight - target.offsetHeight)) <= 1) {
            if (vnode.context.isScrolledDown === false && (vnode.context.tickerBetsHistorical.length >= vnode.context.tickerMaxRealTimeBets || (vnode.context.tickerBetsHistorical.length + vnode.context.tickerBets.length >= vnode.context.tickerMaxRealTimeBets))) {
              if(vnode.context.tickerBetsHistorical.length >0){
                vnode.context.getHistoricalTickerBetsForFilters(vnode.context.tickerBetsHistorical[vnode.context.tickerBetsHistorical.length - 1].id);
                vnode.context.$store.commit('setTickerIsFrozen', true);
              }else{
                if(vnode.context.tickerBets.length >0)
                {
                  vnode.context.getHistoricalTickerBetsForFilters(vnode.context.tickerBets[vnode.context.tickerBets - 1].id);
                  vnode.context.$store.commit('setTickerIsFrozen', true);
                }else{
                  vnode.context.getHistoricalTickerBetsForFilters();
                  vnode.context.$store.commit('setTickerIsFrozen', true);
                }

              }
            }
            vnode.context.isScrolledDown = true;

          } else {
            vnode.context.isScrolledDown = false;
          }
        }.bind(this));
      },
      unbind: function (el, binding, vnode) {
        const target = vnode.context.$el.parentElement;
        target?.removeEventListener('scroll', (e) => {
          if (target.scrollTop === (target.scrollHeight - target.offsetHeight)) {
            console.log('bottom reached');
          }
        });
      }
    },
    topScrolled: {
      inserted: function (el, binding, vnode) {
        const target = vnode.context.$el.parentElement;
        target.addEventListener('scroll', function (e) {
          if (target.scrollTop === 0) {
            vnode.context.$store.commit('moveOnHoldBetsToActiveTickerFeed');
            vnode.context.$store.commit('setTickerIsFrozen', false);
          }
        }.bind(this));
      },
      unbind: function (el, binding, vnode) {
        const target = vnode.context.$el.parentElement;
        target?.removeEventListener('scroll', (e) => {
          if (target.scrollTop === (target.scrollHeight - target.offsetHeight)) {
            console.log('bottom reached');
          }
        });
      }
    }
  }
};
</script>

<style scoped>
  .live-ticker-bet:last-of-type {
    margin-bottom: 8px;
  }

  .ticker {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .ticker-dropdown-wrapper {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
  }

  .ticker-dropdown {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid var(--grey-300);
    border-radius: 4px;
    width: 100%;
    cursor: pointer;
    background-color: white;
  }

  .ticker-dropdown-text {
    display: flex;
    padding: 8px 0px 8px 8px;
    user-select: none;
    overflow: hidden;
  }

  .ticker-dropdown-text > span {
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    color: var(--grey-800);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .ticker-dropdown-selection {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: calc(100% - 28px);
  }

  .ticker-dropdown-dropdown-arrow, .ticker-dropdown-dropdown-arrow > i {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 16px;
    height: 16px;
  }

  .ticker-dropdown-dropdown-arrow {
    margin-right: 4px;
    margin-left: 8px;
  }

  .ticker-dropdown-dropdown-arrow > i {
    font-size: 16px;
    color: var(--grey-900);
  }

  .ticker-dropdown-dropdown-arrow-open > i {
    transform: rotateZ(-180deg);
  }

  .ticker-dropdown-anchor {
    position: relative;
    width: 100%;
  }

  .ticker-dropdown-absolute {
    position: absolute;
    width: 100%;
    z-index: 10;
    top: 4px;
    transition: padding-top 0s 0.4s;
    background: white;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.19);
  }

  .ticker-dropdown-absolute-open {
    top: 4px;
    border-radius: 4px;
    overflow: hidden;
    padding-top: 4px;
    padding-bottom: 4px;
    padding-right: 2px;
    transition: padding-top 0s;
  }

  .ticker-dropdown-contents::-webkit-scrollbar {
    width: 8px;
    background: #f0f0f0;
    /* disabling to make it look like on Firefox
    border-radius: 4px;
    margin-bottom: 4px; */
  }

  .ticker-dropdown-contents::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    /* disabling to make it look like on Firefox
    border-radius: 4px; */
  }

  .ticker-dropdown-contents::-webkit-scrollbar-thumb:hover {
    background: #a6a6a6;
    /* disabling to make it look like on Firefox
    border-radius: 4px; */
  }

  .ticker-dropdown-contents {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    max-height: 0;
    width: 100%;
    overflow: hidden;
    flex-direction: column;
    transition: max-height 0.4s cubic-bezier(0.25, 0.8, 0.5, 1);
    /* border-radius: 4px; */
    /*border: white 1px solid;*/
    background: white;
    scrollbar-width: thin;
  }


  .ticker-dropdown-contents-open {
    overflow-x: hidden !important;
    overflow-y: auto !important;
    max-height: 200px;
  }

  /* not need - it's inside another container
  .ticker-dropdown-contents:first-child {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }

  .ticker-dropdown-contents:last-child {
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  } */

  .ticker-dropdown-item {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    transition: background-color 0.25s ease-in-out;
  }

  .ticker-dropdown-item:hover {
    background: var(--grey-200);
    cursor: pointer;
  }

  .ticker-dropdown-item-selection {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
  }

  .ticker-dropdown-item-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 24px;
    height: 24px;
    margin: 0 4px;
  }

  .ticker-dropdown-item-text {
    display: flex;
    padding: 8px;
    user-select: none;
  }

  .ticker-dropdown-item-text > span {
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    color: var(--grey-800);
  }

  .empty-ticker {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
  }

  .empty-ticker-image {
    display: flex;
    justify-content: center;
    align-items: center;
    max-width: 16px;
    max-height: 16px;
  }

  .empty-ticker-image > .v-icon {
    display: flex;
    align-items: center;
    max-width: 16px;
    max-height: 16px;
    font-size: 16px;
    color: var(--grey-400);
    animation: spin 1s infinite linear;
  }


  .loading-bets {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
    padding-top: 16px;
  }
  .empty-ticker-image > i:before {
    color: var(--grey-400) !important;
  }
  .loading-more-bets-image > i:before {
    color: var(--grey-400) !important;
  }

  .loading-more-bets-image {
    display: flex;
    justify-content: center;
    align-items: center;
    max-width: 16px;
    max-height: 16px;
  }

  .loading-more-bets-image > .v-icon {
    display: flex;
    align-items: center;
    max-width: 16px;
    max-height: 16px;
    font-size: 16px;
    color: var(--grey-400);
    animation: spin 1s infinite linear;
  }
  .loading-more-bets-image > i:before {
    color: var(--grey-400) !important;
  }
  .loading-bets-text {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 16px;
  }

  .loading-bets-text > span {
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    display: flex;
    align-items: center;
    text-align: center;
    color: var(--grey-400);
    padding-left: 8px;
    padding-right: 8px;
  }

  .empty-ticker-text {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8px;
  }

  .empty-ticker-text > span {
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    display: flex;
    align-items: center;
    text-align: center;
    color: var(--grey-400);
    padding-left: 8px;
    padding-right: 8px;
  }

  .ticker-content {
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding: 8px 8px 16px 8px;
    position: relative;
    z-index: 0;
  }

  .ticker-card:not(:first-of-type) {
    margin-top: 8px;
  }

  .ticker-dropdown-container {
    display: flex;
    align-items: flex-end;
    border-bottom: 1px solid var(--grey-200);
    background-color: white;
    position: relative;
    z-index: 1;
  }

  .ticker-dropdown-title {
    padding: 8px;
    background-color: white;
    position: relative;
    z-index: 2;
  }

  .ticker-dropdown-title > span {
    font-size: 12px;
    line-height: 16px;
    color: var(--grey-800);
    /* let it wrap
    white-space: nowrap; */
    overflow: hidden;
    text-overflow: ellipsis;
    padding-bottom: 4px;
    display: block;
  }

  .ticker-dropdown-inline-right {
    padding-right: 4px;
  }

  .ticker-dropdown-inline-left {
    padding-left: 4px;
  }

  .ticker-dropdown-inline {
    display: flex;
    flex-direction: column;
    max-width: 50%;
    width: 100%;
    padding-top: 0px;
  }

  .ticker-dropdown-absolute-full {
    z-index: 100;
  }

  .slide-enter-active, .slide-leave-active {
    transition: transform 0.25s ease-in-out;
  }

  .slide-enter, .slide-leave-to {
    transform: translateY(-154px);
  }

  .slide-move {
    transition: transform 0.25s ease-in-out;
  }

  /*Animations*/

  @keyframes spin {
    0% {
      transform: rotateZ(0)
    }
    100% {
      transform: rotateZ(360deg)
    }
  }

</style>
